import React from "react"
import { RequiredSymbol } from "./various"
import { InputError } from "./inputError"
import { formGroup } from "./formGroup"
import { PropertiesNamesOfType } from "../componentExtensions"

interface TextAreaProps<T> extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "name"> {
    label?: string;
    error?: string;
    helpText?: string;
    name?: PropertiesNamesOfType<T, string | undefined>;
}

export class TextArea<T = any> extends React.PureComponent<TextAreaProps<T>>
{
    private input = React.createRef<HTMLTextAreaElement>();

    render() {
        const { label, error, helpText, value, name, children, className, ...props } = this.props;
        const labelCmp = label ? <label className="form-label" htmlFor={name as any} onClick={e => this.input.current!.focus()}> {label}</label> : undefined;
        const required = this.props.required ? <RequiredSymbol /> : undefined;
        let component = (
            <>
                {labelCmp} {required}
                <textarea className={(className + " form-control").trim()} {...props} value={value ?? ""} ref={this.input} name={name as any} />
                {children}
                <span id="helpBlock" className="form-text" style={{ display: helpText ? "" : "none" }}>{helpText || ""}</span>
                <InputError error={error} />
                <span className="bar" />
            </>);
        if (React.Children.count(children) > 0)
            return <div className="input-group">{component}</div>
        return (component);
    }
}

export const FormTextAreaInput: <T>(props: TextAreaProps<T>) => React.ReactElement | null = formGroup(TextArea as any) as any